import React from 'react';
import { getAnchor } from '~/helpers/anchor';
import useActiveHeaders from '~/helpers/activeHeaders';

const Contents = ({ article }) => {
  const { headings } = article;

  if (headings && headings.length) {
    const { activeHeaders } = useActiveHeaders(headings.map((h) => h.title));

    return (
      <>
        <h3 className="header header__primary">
          <span className="icon icon-burger-left" />
          Contents
        </h3>
        <nav className="nav-quick__container">
          {headings.map((heading, i) => {
            const anchor = getAnchor(heading.title);
            return (
              <a
                key={i}
                href={`#${anchor}`}
                className={`nav-link nav-level--${heading.level - 2} ${activeHeaders.includes(anchor) ? 'active' : ''}`}
              >
                {heading.title}
              </a>
            );
          })}
        </nav>
      </>
    );
  }

  return null;
};

export default Contents;
